//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionAIText(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M19.7637 17.2021L21.9658 18.4834L19.7637 19.7637L18.4834 21.9658L17.2021 19.7637L15 18.4834L17.2021 17.2021L18.4834 15L19.7637 17.2021ZM11.75 17H3V15H11.75V17ZM18 13H3V11H18V13ZM16 9H3V7H16V9ZM20 5H3V3H20V5Z" fill="currentColor" /></svg>;
}
export default IconActionAIText;